<template>
  <v-container fluid py-0>
    <v-row v-if="compact" justify="start" align="center">
      <v-menu :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon outlined color="info" class="mr-2">
            <v-icon>{{ supplierTypeIcon(selectedSupplierType) }}</v-icon>
          </v-btn>
        </template>
        <v-card>
          <template v-if="false">
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Select Suppier Type:</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-container fluid grid-list-xs>
              <v-layout row wrap>
                <v-radio-group v-model="selectedSupplierType">
                  <v-radio
                    v-for="sType in supplierTypes"
                    :key="sType"
                    :value="sType"
                    :label="sType"
                  ></v-radio>
                </v-radio-group>
              </v-layout>
            </v-container>
            <v-divider></v-divider>
            <v-container class="py-0">
              <v-row>
                <v-col>
                  <destination-list
                    :disabled="$apollo.loading"
                    v-model="selectedDestinationId"
                    :outlined="outlinedInputs"
                    dense
                    hide-details
                  ></destination-list>
                </v-col>
              </v-row>
            </v-container>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>More Filters:</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-container>
            <service-type-multi-select
              v-model="serviceTypes"
              :supplier-types="selectedSupplierTypes"
              :outlined="outlinedInputs"
              hide-details
              dense
              @input="onServiceTypeChange"
            />
          </v-container>
          <v-container class="py-0">
            <v-row>
              <v-col>
                <destination-list
                  :disabled="$apollo.loading"
                  v-model="selectedDestinationId"
                  :outlined="outlinedInputs"
                  dense
                  hide-details
                ></destination-list>
              </v-col>
            </v-row>
          </v-container>
          <v-container>
            <stars-list-select
              custom-label="Supplier Rating"
              v-model="ratingFilter"
              :outlined="outlinedInputs"
              dense
              multi
              @input="onRatingChange"
            ></stars-list-select>
          </v-container>
        </v-card>
      </v-menu>
      <v-col
        v-if="splitView && selectedSupplierType != 'TEMPLATE'"
        class="py-0"
      >
        <item-quick-add-split-search
          :items="items"
          :supplier-type-icon="supplierTypeIcon(selectedSupplierType)"
          :edited-item="editedItem"
          @merge="splitView = false"
          v-model="selectedItem"
          @input="onChange"
          @unpriced-supplier="onUnpricedSupplier"
          @unpriced-service="onUnpricedService"
          @supplier-search-input="onSupplierSearchInput"
          :compact="compact"
        ></item-quick-add-split-search>
      </v-col>
      <v-autocomplete
        v-else
        ref="compact-service-select"
        :items="selectedSupplierType != 'TEMPLATE' ? groupedBySupplier : items"
        v-model="selectedItem"
        :label="inputLabel"
        item-text="label"
        item-value="id"
        @input="onChange"
        focusable="true"
        :loading="this.$apollo.loading || loading"
        :search-input.sync="itemSearch"
        @keyup.enter="onItemSearchEnter"
        :append-outer-icon="
          selectedSupplierType != 'TEMPLATE' ? 'mdi-arrow-split-vertical' : null
        "
        @click:append-outer="onSplitView"
        clearable
      >
        <template v-slot:prepend-item v-if="selectedSupplierType != 'TEMPLATE'">
          <v-list-item v-if="itemSearch != '' && itemSearch != undefined">
            <v-list-item-content>
              <v-list-item-title>
                Press
                <kbd @click="onItemSearchEnter">enter</kbd> to add unpriced
                item: " <strong>{{ itemSearch }}</strong
                >"
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-slot:item="data">
          <template v-if="selectedSupplierType == 'TEMPLATE'">
            <v-list-item-content>
              <v-list-item-title v-html="data.item.label"></v-list-item-title>
              <v-list-item-subtitle
                v-html="data.item.description"
              ></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn small text icon color="indigo">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="grey lighten-1"
                      >mdi-information</v-icon
                    >
                  </template>
                  <template-items-grid
                    v-if="data.item.items"
                    v-model="data.item.items.edges"
                  ></template-items-grid>
                </v-tooltip>
              </v-btn>
            </v-list-item-action>
          </template>
          <template v-else>
            <v-list-item-avatar size="32">
              <v-tooltip
                bottom
                v-if="data.item.service && data.item.service.imageURL != ''"
              >
                <template v-slot:activator="{ on }">
                  <v-img
                    v-on="on"
                    :src="
                      data.item.service && data.item.service.imageURL != ''
                        ? data.item.service.imageURL
                        : data.item.supplier
                        ? data.item.supplier.imageURL
                        : null
                    "
                  ></v-img>
                </template>
                <v-container style="max-width: 500px">
                  <v-row>
                    <v-col cols="12">
                      <v-img
                        contain
                        :src="
                          data.item.service && data.item.service.imageURL != ''
                            ? data.item.service.imageURL
                            : data.item.supplier.imageURL
                        "
                      ></v-img>
                    </v-col>
                    <v-col cols="12">
                      <div v-html="data.item.supplier.description"></div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tooltip>
              <v-icon v-else large> mdi-information</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title
                v-html="
                  `${data.item.serviceName} (Price from: ${
                    data.item.priceFrom | priceLabeler
                  }${data.item.priceFromCurrencyCode} ${
                    data.item.rateTypeCode
                  })`
                "
              ></v-list-item-title>
              <v-list-item-subtitle
                v-html="
                  `${data.item.supplierName} (${data.item.supplier.code})`
                "
              ></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn small text icon color="indigo">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="grey lighten-1"
                      >mdi-information</v-icon
                    >
                  </template>
                  <item-prices-grid
                    :items="[...data.item.prices]"
                  ></item-prices-grid>
                </v-tooltip>
              </v-btn>
            </v-list-item-action>
            <v-list-item-action>
              <v-btn
                icon
                color="indigo"
                @click.native.stop="onSupplierDetails(data.item, $event)"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small>mdi-pencil</v-icon>
                  </template>
                  Edit {{ data.item.supplierName }}
                </v-tooltip>
              </v-btn>
            </v-list-item-action>
          </template>
        </template>
      </v-autocomplete>
    </v-row>
    <v-layout v-else wrap align-center justify-center>
      <v-flex xs12>
        <v-layout wrap justify-center align-baseline>
          <v-flex xs12 sm3>
            <destination-list
              :disabled="$apollo.loading"
              v-model="selectedDestinationId"
              :outlined="outlinedInputs"
            ></destination-list>
          </v-flex>
          <v-flex xs12 sm9>
            <v-row justify="start" align="baseline" class="pl-4">
              <v-radio-group
                v-model="selectedSupplierType"
                row
                :disabled="$apollo.loading"
              >
                <v-radio
                  v-for="sType in supplierTypes"
                  :key="sType"
                  :value="sType"
                  class="pr-2"
                >
                  <template v-slot:label>
                    <v-icon>{{ supplierTypeIcon(sType) }}</v-icon>
                  </template>
                </v-radio>
                <v-radio value="TEMPLATE">
                  <template v-slot:label>
                    <v-icon>mdi-ballot</v-icon>
                  </template>
                </v-radio>
                <v-radio
                  v-if="false"
                  label="REZGRAPH"
                  value="REZGRAPH"
                ></v-radio>
              </v-radio-group>
              <v-btn
                :disabled="$apollo.loading"
                color="primary"
                @click="
                  $emit('showAdhoc', {
                    supplierType: selectedSupplierType,
                    destinationId: selectedDestinationId,
                  })
                "
                text
              >
                <v-icon left>mdi-plus-circle</v-icon>Add Unpriced Item
              </v-btn>
            </v-row>
          </v-flex>
          <v-flex xs12 sm2 text-sm-right v-if="false">
            <v-btn
              :disabled="$apollo.loading"
              color="primary"
              @click="
                $emit('showAdhoc', {
                  supplierType: selectedSupplierType,
                  destinationId: selectedDestinationId,
                })
              "
              text
            >
              <v-icon left>mdi-plus-circle</v-icon>Add Unpriced Item
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <item-quick-add-split-search
          v-if="splitView && selectedSupplierType != 'TEMPLATE'"
          :items="items"
          :supplier-type-icon="supplierTypeIcon(selectedSupplierType)"
          @merge="splitView = false"
          v-model="selectedItem"
          @input="onChange"
          @unpriced-supplier="onUnpricedSupplier"
          @unpriced-service="onUnpricedService"
          @supplier-search-input="onSupplierSearchInput"
          :loading="$apollo.loading"
          :edited-item="editedItem"
        ></item-quick-add-split-search>
        <v-autocomplete
          v-else
          ref="service-select"
          :items="
            selectedSupplierType != 'TEMPLATE' ? groupedBySupplier : items
          "
          v-model="selectedItem"
          :label="inputLabel"
          item-text="label"
          item-value="id"
          @input="onChange"
          focusable="true"
          :loading="$apollo.loading || loading"
          :prepend-inner-icon="supplierTypeIcon(selectedSupplierType)"
          :search-input.sync="itemSearch"
          @keyup.enter="onItemSearchEnter"
          :append-outer-icon="
            selectedSupplierType != 'TEMPLATE'
              ? 'mdi-arrow-split-vertical'
              : null
          "
          @click:append-outer="onSplitView"
          clearable
          :outlined="outlinedInputs"
        >
          <template
            v-slot:prepend-item
            v-if="selectedSupplierType != 'TEMPLATE'"
          >
            <v-list-item v-if="itemSearch != '' && itemSearch != undefined">
              <v-list-item-content>
                <v-list-item-title>
                  Press
                  <kbd @click="onItemSearchEnter">enter</kbd> to add unpriced
                  item: " <strong>{{ itemSearch }}</strong
                  >"
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:no-data v-if="false">
            <v-list-item v-if="itemSearch != '' && itemSearch != undefined">
              <v-list-item-content>
                <v-list-item-title>
                  <v-btn
                    small
                    class="ma-1"
                    outlined
                    @click="onSearchBySupplierName"
                  >
                    <v-icon left>mdi-magnify</v-icon>Click </v-btn
                  >to search for " <strong>{{ itemSearch }}</strong
                  >"
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-slot:item="data">
            <template v-if="selectedSupplierType == 'TEMPLATE'">
              <v-list-item-content>
                <v-list-item-title v-html="data.item.label"></v-list-item-title>
                <v-list-item-subtitle
                  v-html="data.item.description"
                ></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn small text icon color="indigo">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="grey lighten-1"
                        >mdi-information</v-icon
                      >
                    </template>
                    <template-items-grid
                      v-if="data.item.items"
                      v-model="data.item.items.edges"
                    ></template-items-grid>
                  </v-tooltip>
                </v-btn>
              </v-list-item-action>
            </template>
            <template v-else>
              <v-list-item-avatar size="32">
                <v-tooltip
                  bottom
                  v-if="
                    (data.item.service && data.item.service.imageURL != '') ||
                    (data.item.supplier &&
                      (data.item.supplier.imageURL ||
                        data.item.supplier.description))
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-img
                      v-on="on"
                      :src="
                        data.item.service && data.item.service.imageURL != ''
                          ? data.item.service.imageURL
                          : data.item.supplier
                          ? data.item.supplier.imageURL
                          : null
                      "
                    ></v-img>
                  </template>
                  <v-container style="max-width: 500px">
                    <v-row>
                      <v-col cols="12">
                        <v-img
                          contain
                          max-height="200"
                          :src="
                            data.item.service &&
                            data.item.service.imageURL != ''
                              ? data.item.service.imageURL
                              : data.item.supplier.imageURL
                          "
                        ></v-img>
                      </v-col>
                      <v-col cols="12">
                        <div
                          class="max-lines"
                          v-html="data.item.supplier.description"
                        ></div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tooltip>
                <v-icon v-else large> mdi-information</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle
                  v-html="
                    `${data.item.supplierName} (${data.item.supplier.code})`
                  "
                ></v-list-item-subtitle>
                <v-list-item-title
                  v-html="
                    `${data.item.serviceName} (Price from: ${
                      data.item.priceFrom | priceLabeler
                    }${data.item.priceFromCurrencyCode} ${
                      data.item.rateTypeCode
                    })`
                  "
                ></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn small text icon color="indigo">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="grey lighten-1"
                        >mdi-information</v-icon
                      >
                    </template>
                    <item-prices-grid
                      :items="[...data.item.prices]"
                    ></item-prices-grid>
                  </v-tooltip>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action>
                <v-btn
                  small
                  text
                  icon
                  color="indigo"
                  @click.native.stop="onSupplierDetails(data.item, $event)"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small>mdi-pencil</v-icon>
                    </template>
                    Edit {{ data.item.supplierName }}
                  </v-tooltip>
                </v-btn>
              </v-list-item-action>
            </template>
          </template>
        </v-autocomplete>
      </v-flex>

      <v-flex xs2 text-xs-left pt-2 v-if="false">
        <v-btn
          color="success"
          :disabled="selectedItem == '' || selectedItem == undefined"
          @click.stop="onAdd"
          >Add</v-btn
        >
      </v-flex>
    </v-layout>

    <div v-if="debug">
      <code>edited item {{ editedItem }}</code>

      <hr />
    </div>
  </v-container>
</template>

<script>
import { SUPPLIER_TYPES } from "../../../../constants/supplierTypes";
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";
import {
  SEARCH_MUTATION,
  SEARCH_RESULTS_QUERY,
  SEARCH_RESULTS_SUBSCRIPTION,
} from "../../../../constants/rezGraphQL";
import DatePicker from "../../shared/DatePicker";
import DestinationList from "../../shared/DestinationListSelect";
import ServiceTypeMultiSelect from "../../shared/ServiceTypeMultiSelect.vue";
import StarsListSelect from "../../shared/StarsListSelect.vue";
import {
  AVAILABLE_SERVICES_SEARCH_QUERY,
  QUICK_ADD_TEMPLATES_SEARCH_QUERY,
} from "../../../../constants/graphql";
import ItemQuickAddSplitSearch from "./ItineraryBuilderItemQuickAddSplitSearch";
import ItemPricesGrid from "./ItineraryBuilderItemQuickAddItemPricesGrid";
import TemplateItemsGrid from "./ItineraryBuilderItemQuickAddTemplateItems";
var moment = require("moment");
export default {
  name: "ItineraryBuilderItemQuickAdd",
  props: {
    startDate: {
      type: String,
    },
    duration: {
      type: Number,
    },
    destinationId: {
      type: String,
    },
    destination: {
      type: Object,
    },
    adults: {
      type: String,
    },
    children: {
      type: String,
    },
    infants: {
      type: String,
    },
    focusOnSelect: {
      type: Boolean,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    selectedItemId: {
      type: String,
    },
    serviceType: {
      type: String,
      default: "ACCOMMODATION",
    },
    departmentName: {
      type: String,
      default: () => "",
    },
    editedItem: {
      type: Object,
      default: () => null,
    },
  },
  mixins: [SupplierTypeIconMixin],
  components: {
    DatePicker,
    DestinationList,
    ItemQuickAddSplitSearch,
    ItemPricesGrid,
    TemplateItemsGrid,
    ServiceTypeMultiSelect,
    StarsListSelect,
  },

  data() {
    return {
      debug: false,
      menuOpenOnHover: true,
      splitView: this.compact,
      items: [],
      menu: false,
      radius: 1,
      selectedItem: this.selectedItemId,
      selectedStartDate: this.startDate || "",
      selectedEndDate: this.startDate
        ? moment(this.startDate).add(this.duration, "days").toISOString(true)
        : "",
      selectedDuration: this.duration || 1,
      selectedSupplierType: this.serviceType,
      supplierTypes: SUPPLIER_TYPES,
      selectedDestinationId:
        this.destinationId ||
        (this.destination && this.destination.id ? this.destination.id : ""),
      selectedDestination: this.destination,
      selectedAdults: this.adults || "2",
      selectedChildren: this.children || "0",
      selectedInfants: this.infants || "0",
      skipTemplatesQuery: true,
      availableServices: {},
      templates: {},
      skipRezGraphQuery: true,
      rezGraphSearchToken: "",
      searchResult: {},
      loading: false,
      itemSearch: "",
      supplierNameFilter: this.editedItem ? this.editedItem.supplierName : null,
      searchTimeout: null,
      searchDebounceTime: 700,
      serviceTypes: [],
      ratingFilter: [],
    };
  },

  methods: {
    onServiceTypeChange() {
      this.supplierNameFilter = null;
    },
    onRatingchange() {
      this.supplierNameFilter = null;
    },
    onSupplierDetails(item, event) {
      this.$emit("supplier-edit", item);
    },
    onSplitView() {
      this.splitView = !this.splitView;
    },
    onUnpricedSupplier(event) {
      this.$emit("showAdhoc", {
        supplierType: this.selectedSupplierType,
        destinationId: this.selectedDestinationId,
        supplierName: event,
      });
    },
    onUnpricedService(event) {
      this.$emit("showAdhoc", {
        supplierType: this.selectedSupplierType,
        destinationId: this.selectedDestinationId,
        ...event,
      });
    },
    onItemSearchEnter(event) {
      this.$emit("showAdhoc", {
        supplierType: this.selectedSupplierType,
        destinationId: this.selectedDestinationId,
        supplierName: this.itemSearch,
      });
    },
    onSearch() {
      this.menuOpenOnHover = true;
      this.menu = false;
    },
    onMenuMouseOver(event) {
      this.menuOpenOnHover = false;
    },
    onStartNewRezGraphSearch() {
      this.startRezGraphSearch();
    },
    onDestinationSelect($event) {
      this.selectedDestination = $event;
      this.selectedDestinationId = $event.id;
    },
    updateDates() {
      let startDate = moment(this.selectedStartDate);
      const duration = Number(this.selectedDuration);
      if (startDate.isValid()) {
        this.selectedEndDate = startDate
          .add(Number(duration), "days")
          .toISOString(true);
      }
      //this.validate();
    },
    // validate() {
    //   let valid = this.selectedDestinationId != undefined;
    //   valid = valid && this.agentId != undefined;

    //   valid =
    //     valid && this.selectedStartDate != "" && this.selectedEndDate != "";
    //   //console.log('validation check: ', this.selectedDuration, valid);
    // },
    serviceLabelizer(item) {
      return `${item.supplierName} (${item.supplier.code}) - ${item.serviceName} (Price from: ${item.priceFrom}${item.priceFromCurrencyCode} ${item.rateTypeCode})`;
    },
    templateLabelizer(item) {
      return `${item.name} / ${item.destination.name} (Duration: ${item.duration})`;
    },
    getSelectedTemplateData(selectedItem) {
      return { ...selectedItem };
    },
    getSelectedServiceData(selectedItem) {
      let serviceType = this.selectedSupplierType;
      if (serviceType == "REZGRAPH") {
        serviceType = "ACCOMMODATION";
      }
      const stdOccupancy = selectedItem.service
        ? parseInt(selectedItem.service.stdOccupancy)
        : 0;
      const pax =
        parseInt(this.selectedAdults) + parseInt(this.selectedChildren);
      const qty =
        stdOccupancy > 0 ? String(Math.ceil(pax / stdOccupancy)) : "1";
      return {
        ...selectedItem,
        boardBasis: selectedItem.supplier
          ? selectedItem.supplier.boardBasis
          : "",
        startDate: this.selectedStartDate,
        endDate: this.selectedEndDate,
        serviceType,
        price: selectedItem.priceFrom,
        currencyCode: selectedItem.priceFromCurrencyCode,
        qty,
        adults: this.selectedAdults,
        children: this.selectedChildren,
        infants: this.selectedInfants,
      };
    },
    onAdd() {
      if (this.selectedItem) {
        if (!this.compact && !this.splitView) {
          this.$refs["service-select"].blur();
        }
        const selectedItem = this.items.find(
          (item) => item.id == this.selectedItem
        );
        let selectedItemData;
        if (selectedItem.__typename == "Template") {
          selectedItemData = this.getSelectedTemplateData(selectedItem);
        } else {
          selectedItemData = this.getSelectedServiceData(selectedItem);
        }
        if (selectedItem) {
          //console.log(selectedItemData);

          this.$emit("onSelect", selectedItemData);
          // this.$nextTick(() => {
          //   this.selectedItem = null;
          // });
        }
      }
    },
    onChange($event) {
      //refactor this later
      //if (this.compact) {
      this.onAdd();
      //this.selectedItem = null;
      //}
    },
    async startRezGraphSearch() {
      //console.log("creating search in rezgraph...");
      this.items = [];
      this.loading = true;
      //console.log("new search");
      try {
        const searchRes = await this.$apollo.mutate({
          client: "rezGraph",
          mutation: SEARCH_MUTATION,
          variables: {
            start: this.selectedStartDate.split("T")[0],
            end: this.selectedEndDate.split("T")[0],
            rooms: this.rezGraphRooms(),
            lon: this.selectedDestination.geolocation.split(",")[1],
            lat: this.selectedDestination.geolocation.split(",")[0],
            radius: this.radius * 1000,
          },
        });

        this.rezGraphSearchToken = searchRes.data.search.token;
        //get search results
        this.skipRezGraphQuery = false;
        this.loading = true;
      } catch (err) {
        this.loading = false;
        alert(err);
      }
    },
    rezGraphRooms() {
      const children = [];
      for (let i = 1; i <= this.children; i++) {
        //what the default age for child in gtweb?
        children.push({ age: 10 });
      }
      return [{ adults: Number(this.adults), children }];
    },
    setFocusOnSelect() {
      //skip it on split view
      if (this.splitView) {
        return;
      }
      if (this.compact) {
        this.$refs["compact-service-select"].$el.querySelector("input").focus();
      } else {
        this.$refs["service-select"].$el.querySelector("input").focus();
      }
    },
    onSearchBySupplierName() {
      this.supplierNameFilter = this.itemSearch;
    },
    onSupplierSearchInput(payload) {
      console.log("supplier input", payload);
      this.supplierNameFilter = payload;
    },
  },

  computed: {
    selectedSupplierTypes() {
      return [
        this.selectedSupplierType == "ACCOMMODATION"
          ? "HOTELS"
          : this.selectedSupplierType,
      ];
    },
    agentId() {
      return this.$store.getters.itineraryAgentId;
    },
    skipQuery() {
      let valid = this.selectedDestinationId != undefined;
      valid = valid && this.agentId != undefined;

      valid =
        valid && this.selectedStartDate != "" && this.selectedEndDate != "";

      return !valid;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    inputLabel() {
      return this.$apollo.loading
        ? "Loading data..."
        : `Search for ${this.selectedSupplierType} (Showing ${this.items.length} results)`;
    },
    radiusLabel() {
      return `${this.radius} km`;
    },
    destinationLabel() {
      return `Location: ${this.selectedDestination.geolocation}`;
    },
    groupedBySupplier() {
      let supplier = "";
      const items = [];
      for (let item of this.items) {
        if (supplier != item.supplierId) {
          if (supplier != "") {
            items.push({ divider: true });
          }
          items.push({ header: item.supplierName });
          supplier = item.supplierId;
        }
        items.push(item);
      }
      return this.items.length > 0 ? items : [];
    },
  },
  watch: {
    duration(val) {
      this.selectedDuration = val;
      this.updateDates();
    },
    startDate(val) {
      this.selectedStartDate = val;
      this.updateDates();
    },
    destinationId: function (val) {
      this.selectedDestinationId = val;
    },
    destination: function (val) {
      this.selectedDestination = val;
      this.selectedDestinationId = val.id;
    },
    adults: function (val) {
      this.selectedAdults = val;
    },
    children: function (val) {
      this.selectedChildren = val;
    },
    infants: function (val) {
      this.selectedInfants = val;
    },
    focusOnSelect: function (val) {
      if (val) {
        this.setFocusOnSelect;
      }
    },
    selectedSupplierType: function (val) {
      this.skipTemplatesQuery = val != "TEMPLATE";
      this.selectedItem = "";
      if (val == "REZGRAPH") {
        if (this.selectedDestination.geolocation) {
          this.startRezGraphSearch();
          // if (this.rezGraphSearchToken == "") {
          //   this.startRezGraphSearch();
          // } else {
          //   this.skipRezGraphQuery = false;
          // }
        } else {
          alert("Cannot search destination withoud geolocation");
        }
      } else {
        this.skipRezGraphQuery = true;
      }
      //this.focusOnSelect = true;
      this.setFocusOnSelect();
    },
    menu(v) {
      if (v === true) {
        this.$refs["service-select"].blur();
      }
    },
    itemSearch(newVal) {
      if (newVal == null || newVal.indexOf("Price from:") != -1) {
        clearTimeout(this.searchTimeout);
        return;
      }
      clearTimeout(this.searchTimeout);
      if (!this.selectedItem && newVal != null) {
        this.searchTimeout = setTimeout(() => {
          this.supplierNameFilter = newVal;
        }, this.searchDebounceTime);
      }
    },
  },
  apollo: {
    availableServices: {
      query: AVAILABLE_SERVICES_SEARCH_QUERY,
      variables() {
        return {
          destinationId: this.selectedDestinationId,
          agentId: this.agentId,
          startDate: this.selectedStartDate,
          endDate: this.selectedEndDate,
          serviceType: this.selectedSupplierType,
          adults: this.selectedAdults,
          children: this.selectedChildren,
          infants: this.selectedInfants,
          supplierName: this.supplierNameFilter,
          department:
            this.departmentName != "" ? this.departmentName : undefined,
          serviceTypeNames: [...this.serviceTypes],
          ratings: [...this.ratingFilter],
          qty: "1",
          first: 100,
        };
      },
      skip() {
        return this.skipQuery;
      },
      result({ data, loader, networkStatus }) {
        if (data && data.availableServices) {
          this.items = data.availableServices.edges.map((node) => ({
            ...node.node,
            label: this.serviceLabelizer(node.node),
          }));
        }
        this.loading = false;
      },
      fetchPolicy: "network-only",
    },
    templates: {
      query: QUICK_ADD_TEMPLATES_SEARCH_QUERY,
      fetchPolicy: "network-only",
      skip() {
        return this.skipTemplatesQuery;
      },
      result({ data, loader, networkStatus }) {
        if (data) {
          this.items = data.templates.edges.map((node) => ({
            ...node.node,
            label: this.templateLabelizer(node.node),
            isTemplate: true,
          }));
          //console.log(data);
        }
      },
    },
    searchResult: {
      client: "rezGraph",
      query: SEARCH_RESULTS_QUERY,
      variables() {
        return {
          token: this.rezGraphSearchToken,
        };
      },
      subscribeToMore: {
        document: SEARCH_RESULTS_SUBSCRIPTION,
        // Variables passed to the subscription. Since we're using a function,
        // they are reactive
        variables() {
          return {
            token: this.rezGraphSearchToken,
          };
        },
        // Mutate the previous result
        updateQuery: (previousResult, { subscriptionData }) => {
          return {
            searchResult: {
              ...subscriptionData.data.searchResult,
            },
          };
        },
      },
      skip() {
        return this.skipRezGraphQuery;
      },
      result({ data }) {
        if (data.searchResult.items.length > 0) {
          this.loading = false;
          this.items = data.searchResult.items.map((item) => {
            return {
              id: item.id,
              serviceName: item.name,
              supplierName: "RezGraph",
              source: {
                name: "REZGRAPH",
                id: item.id,
                supplierName: item.pimName,
                serviceName: item.name,
                confirmationRef: "",
              },
              serviceId: item.id,
              supplierId: item.id,
              priceFrom: item.price,
              priceFromCurrencyCode: "EUR",
              label: `(${item.pimName})${item.name} - (Price from: ${item.price}EUR)`,
              pricing: {
                currencyBuy: "EUR",
                currencySell: "EUR",
                rateTypeCode: "TOTAL",
                itemBuy: item.price / this.duration,
                itemSell: item.price / this.duration,
                adultBuy: 0,
                adultSell: 0,
                childBuy: 0,
                childSell: 0,
                infantBuy: 0,
                infantSell: 0,
              },
            };
          });
        }
      },
    },
  },
  mounted() {
    if (this.compact) {
      //this.updateDates();
      //this.validate();
      // if (this.focusOnSelect) {
      //   this.$refs["compact-service-select"].$el.querySelector("input").focus();
      // }
    }
  },
};
</script>
<style scoped>
.max-lines {
  display: block; /* or inline-block */
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
  max-height: 7.2em;
  line-height: 1.8em;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderItemQuickAdd.vue